import { render } from "./ProfileSettings.vue?vue&type=template&id=fc8b2b1e&lang=pug"
import script from "./ProfileSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__